var map = {
	"./ar.json": "af08",
	"./bn.json": "8782",
	"./da.json": "21aa",
	"./de.json": "6ce2",
	"./en.json": "edd4",
	"./en_AU.json": "a725",
	"./en_GB.json": "3064",
	"./es.json": "a306",
	"./fa.json": "15ad",
	"./fi.json": "5754",
	"./fr.json": "f693",
	"./hi.json": "7a03",
	"./id.json": "210c",
	"./it.json": "0825",
	"./ja.json": "0423",
	"./ja_KS.json": "7f1d",
	"./ko.json": "dd11",
	"./mn.json": "7bf5",
	"./ms.json": "2060",
	"./my.json": "3ecc",
	"./nl.json": "a625",
	"./pl.json": "89b2",
	"./pt.json": "5d67",
	"./ro.json": "9542",
	"./ru.json": "7704",
	"./sv.json": "4c5b",
	"./sw.json": "0e32",
	"./ta.json": "2393",
	"./th.json": "8680",
	"./tr.json": "ffeb",
	"./ur.json": "621c",
	"./vi.json": "aced",
	"./zh-CN.json": "423e",
	"./zh-TW.json": "9ea5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";